import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import Layout from './layouts/Layout';
import LayoutParking from './layouts/LayoutParking';

import Config from 'utils/config';

const App = () => {
  let AppLayout = Layout;
  if (Config.apptype === 'parking') {
    AppLayout = LayoutParking
  }
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppLayout />
    </Router>
  );
};

export default App;
